"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

const legacyScripts = [
  "/js/jquery-1.11.3.min.js",
  "/js/bootstrap.min.js",
  "/js/imagesloaded.pkgd.min.js",
  "/isotope/jquery.isotope.min.js",
  "/js/wow.min.js",
  "/js/theme.min.js",
];

const routesWithoutLegacyScripts = new Set([
  "/tao-phieu-yeu-cau-van-chuyen",
]);

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);

    if (existing?.dataset.loaded === "true") {
      resolve();
      return;
    }

    if (existing) {
      existing.addEventListener("load", resolve, { once: true });
      existing.addEventListener("error", reject, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = false;
    script.dataset.legacy = "true";
    script.addEventListener(
      "load",
      () => {
        script.dataset.loaded = "true";
        resolve();
      },
      { once: true }
    );
    script.addEventListener("error", reject, { once: true });
    document.body.appendChild(script);
  });
}

export default function LegacyScripts() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === "/" || routesWithoutLegacyScripts.has(pathname)) return;

    let cancelled = false;

    const loadAll = async () => {
      for (const src of legacyScripts) {
        if (cancelled) return;
        try {
          await loadScript(src);
        } catch {
          return;
        }
      }
    };

    const schedule = () => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(loadAll, { timeout: 3000 });
      } else {
        window.setTimeout(loadAll, 1500);
      }
    };

    if (document.readyState === "complete") {
      schedule();
    } else {
      window.addEventListener("load", schedule, { once: true });
    }

    return () => {
      cancelled = true;
      window.removeEventListener("load", schedule);
    };
  }, [pathname]);

  return null;
}
